import { jsx as _jsx } from "react/jsx-runtime";
import { AddressFieldName } from '@as-react/common-types';
import { generateFieldName } from '../addressFields.utils';
import { mapWithAssert } from '../../../../util/ArrayUtil';
import { useFeatureToggle } from '../../../../hooks/useFeatureToggle';
import { AddressFieldsBEDefault } from './AddressFieldsBEDefault';
import { AddressFieldsBEWithValidation } from './AddressFieldsBEWithValidation';
export const AddressFieldsBE = (props) => {
    const fieldsName = [
        AddressFieldName.ADDRESS,
        AddressFieldName.HOUSE_NUMBER,
        AddressFieldName.HOUSE_NUMBER_ADDITION,
        AddressFieldName.POSTCODE,
        AddressFieldName.CITY,
        AddressFieldName.CUSTOM_TOWN,
    ];
    const fields = mapWithAssert(fieldsName, name => generateFieldName(name, props.prefix));
    const bpost_address_validation = useFeatureToggle('bpost_address_validation');
    return bpost_address_validation ? (_jsx(AddressFieldsBEWithValidation, Object.assign({}, props, { fields: fields }))) : (_jsx(AddressFieldsBEDefault, Object.assign({}, props, { fields: fields })));
};
